// import axios from 'axios';

// const apiClient = axios.create({
//   baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api',
//   headers: {
//     'Content-Type': 'application/json'
//   }
// });

// // Attach token + tenant
// apiClient.interceptors.request.use((config) => {
//   const token = localStorage.getItem('token');
//   const tenantId = localStorage.getItem('tenantId');

//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   if (tenantId) {
//     config.headers['X-tenant-id'] = tenantId;
//   }

//   return config;
// });

// // Response interceptor for handling auth errors
// apiClient.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       // Token expired or invalid
//       localStorage.removeItem('token');
//       localStorage.removeItem('isAuthenticated');
//       localStorage.removeItem('user');
//       localStorage.removeItem('role');
//       localStorage.removeItem('tenantId');
      
//       // Redirect to login if not already there
//       if (window.location.pathname !== '/login') {
//         window.location.href = '/login';
//       }
//     }
//     return Promise.reject(error);
//   }
// );

// export default apiClient;

// src/api/client.js
import axios from 'axios';

const apiClient = axios.create({
  // baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api',
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://brudhi.com/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Attach token + tenant
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  
  // ✅ Get tenant ID from multiple sources
  let tenantId = localStorage.getItem('tenantId');
  
  // If tenantId not found, try to get it from user object
  if (!tenantId) {
    try {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const user = JSON.parse(userStr);
        tenantId = user?.tenant_id;
      }
    } catch (e) {
      console.warn('Failed to parse user:', e);
    }
  }
  
  // If still not found, try from tenant object
  if (!tenantId) {
    try {
      const tenantStr = localStorage.getItem('tenant');
      if (tenantStr) {
        const tenant = JSON.parse(tenantStr);
        tenantId = tenant?.id;
      }
    } catch (e) {
      console.warn('Failed to parse tenant:', e);
    }
  }

  // ✅ Debug log
  console.log('📤 API Request:', {
    url: config.url,
    method: config.method,
    tenantId: tenantId || 'NOT SET',
    hasToken: !!token
  });

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // ✅ Always set tenant ID if available
  if (tenantId) {
    config.headers['X-tenant-id'] = String(tenantId);
  } else {
    console.warn('⚠️ No tenant ID found! Using default 7');
    config.headers['X-tenant-id'] = '7'; // Default fallback
  }

  return config;
});

// Response interceptor for handling auth errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('user');
      localStorage.removeItem('role');
      localStorage.removeItem('tenantId');
      localStorage.removeItem('tenant');
      
      // Redirect to login if not already there
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;